import React, { useState, useEffect } from 'react';
import _get from 'lodash/get';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useLocation, useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useStatus } from 'resift';
import { setWidgetTypes, setWidgets } from 'store/homepageWidgets';
import createWidget from 'fetches/homepageWidgets/createWidget';
import showSnackbar from 'helpers/showSnackbar';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Loader from 'components/Loader';
import Page from 'components/Page/newComponents';
import BackButton from 'components/Page/BackButton';
import WidgetSelectType from 'pages/Homepage/components/WidgetSelectType';
import WidgetSetName from 'pages/Homepage/components/WidgetSetName';
import WidgetEdit from 'pages/Homepage/components/WidgetEdit';
import { HOME_URL, HOMEPAGE_URL, WIDGETS_URL } from 'components/Router/consts';
import { WidgetType, Widget } from 'pages/Homepage/typings';

interface Props {
  widgetTypes: Array<WidgetType>;
  widgets: Array<Widget>;
  status: number;
}

function WidgetConfiguration({ widgetTypes, widgets, status }: Props) {
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [currentSlideIndex, setSlideIndex] = useState(0);
  const widgetTypesInRedux: Array<WidgetType> = useSelector(state =>
    _get(state, ['homepageWidgets', 'widgetTypes']),
  );
  const widgetsInRedux: Array<Widget> = useSelector(state =>
    _get(state, ['homepageWidgets', 'widgets']),
  );
  const createWidgetStatus = useStatus(createWidget);

  showSnackbar({
    status: createWidgetStatus,
    message: 'Successfully created widget.',
    variant: 'success',
    errorMessage: 'An error occurred while creating the widget.',
  });

  useEffect(() => {
    if (location.pathname.match(/create\/types\/.*/)) {
      setSlideIndex(1);
    } else if (location.pathname.includes('create/types')) {
      setSlideIndex(0);
    } else {
      setSlideIndex(2);
    }
  }, [location]);

  useEffect(() => {
    dispatch(setWidgetTypes(widgetTypes));
    dispatch(setWidgets(widgets));
  }, []);

  if (!widgetTypesInRedux || !widgetsInRedux) {
    return <CircularProgress color="secondary" />;
  }

  const handleClose = () => {
    history.push(`${HOME_URL}${HOMEPAGE_URL}${WIDGETS_URL}`);
  };

  const currentSlideContent =
    currentSlideIndex === 0 ? (
      <WidgetSelectType />
    ) : currentSlideIndex === 1 ? (
      <WidgetSetName />
    ) : currentSlideIndex === 2 ? (
      <WidgetEdit onDone={handleClose} />
    ) : null;

  return (
    <Dialog
      classes={{ paper: classes.paper }}
      open
      onClose={handleClose}
      fullScreen
      aria-labelledby="edit-attributes-modal"
    >
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Typography
            id="edit-attributes-modal"
            variant="h6"
            color="inherit"
            className={classes.flex}
          >
            Configure Widget
          </Typography>
          <Button color="inherit" onClick={handleClose} className={classes.cancelButton}>
            Back to Widget List
          </Button>
        </Toolbar>
      </AppBar>
      <Page classes={{ root: classes.pageRoot }}>
        <Loader status={status}>{() => currentSlideContent}</Loader>
      </Page>
    </Dialog>
  );
}

const useStyles = makeStyles((theme: any) => ({
  appBar: {
    position: 'relative',
    backgroundColor: '#2f2f32',
  },
  pageRoot: {
    display: 'flex',
    flex: '1 1 auto',
    height: 'calc(100vh - 64px)',
  },
  toolbar: {
    paddingRight: theme.spacing(4),
  },
  cancelButton: {
    marginRight: theme.spacing(1),
  },
  flex: {
    flex: 1,
  },
  paper: {
    background: '#F9FBFD',
  },
  backButtonIcon: {
    color: theme.palette.common.white,
  },
}));

export default WidgetConfiguration;
